// Authored by opencode-go/glm-5.3; Matthew, Hermes and unslop editing pass.
export const careConnectCopy = {
  "connectTitle": "Connect a client",
  "clientEmailLabel": "Client email",
  "clientNameLabel": "Display name",
  "connectButton": "Connect client",
  "connectHelp": "Links a confirmed account to you. The client must have signed in to Regulated first. This form does not email the client or create an account.",
  "connectError": "We could not connect this client. Check the email and that the client has signed in to Regulated, then try again.",
  "connectSuccess": "Client connected. You can now select them to assign tasks or send a message.",
  "connecting": "Connecting client..."
}
